import React, { createContext, useContext, useState, ReactNode } from "react";
import { useQueryClient } from "react-query";

interface ZahllaufContextType {
  searchValue: string;
  setSearchValue: (value: string) => void;
  inputValue: any;
  setInputValue: (value: any) => void;
  selectedZahllaufId: string | null;
  setSelectedZahllaufId: (id: string | null) => void;
  invalidateCurrentZahllauf: () => void;
  serverKeyVersion: number;
  incrementServerKeyVersion: () => void;
}

const ZahllaufContext = createContext<ZahllaufContextType | undefined>(
  undefined
);

export function ZahllaufProvider({ children }: { children: ReactNode }) {
  const [searchValue, setSearchValue] = useState("");
  const [inputValue, setInputValue] = useState<any>(null);
  const [selectedZahllaufId, setSelectedZahllaufId] = useState<string | null>(
    null
  );
  const [serverKeyVersion, setServerKeyVersion] = useState<number>(0);
  const incrementServerKeyVersion = () =>
    setServerKeyVersion((v: number) => v + 1);
  const queryClient = useQueryClient();
  const invalidateCurrentZahllauf = () => {
    if (selectedZahllaufId) {
      queryClient.invalidateQueries(["zahllauf", selectedZahllaufId]);
    }
  };

  return (
    <ZahllaufContext.Provider
      value={{
        searchValue,
        setSearchValue,
        inputValue,
        setInputValue,
        selectedZahllaufId,
        setSelectedZahllaufId,
        invalidateCurrentZahllauf,
        serverKeyVersion,
        incrementServerKeyVersion,
      }}
    >
      {children}
    </ZahllaufContext.Provider>
  );
}

export function useZahllaufContext() {
  const context = useContext(ZahllaufContext);
  if (context === undefined) {
    throw new Error(
      "useZahllaufContext must be used within a ZahllaufProvider"
    );
  }
  return context;
}
